import api from '../../lib/api'
import moment from 'moment'

function formCleanerAndArranger(form) {
  form.filter.startDate = moment(form.filter.startDate).unix()
  form.filter.endDate = moment(form.filter.endDate).unix()

  // if form.filter.providerid is an array that has one item, then convert it to integer
  if (form.filter.providerid.length === 1)
    form.filter.providerid = parseInt(form.filter.providerid[0])

  // if form.filter.gameid is an array that has one item, then convert it to integer
  if (form.filter.gameid.length === 1)
    form.filter.gameid = parseInt(form.filter.gameid[0])

  Object.keys(form.filter).forEach(key => {
    let isZeroOrNull = form.filter[key] === 0 || form.filter[key] === null
    let isEmptyArray =
      Array.isArray(form.filter[key]) && !form.filter[key].length
    if (isZeroOrNull || isEmptyArray) delete form.filter[key]
  })
  return form
}

const STAT_URL =
  window.location.hostname === 'localhost'
    ? 'https://mintgamingapi.com'
    : `${window.location.host}`

export default {
  namespaced: true,
  state: {
    list: [],
    sum: {},
    mostProfited: [],
    mostLost: [],
    limit: 10,
    loading: true,
    bigLoading: true,
    noData: false,
    totals: {
      plus: {},
      minus: {}
    }
  },
  mutations: {
    setSum(state, data) {
      state.sum = data
    },
    setList(state, data) {
      state.list = data
    },
    setMostProfited(state, data) {
      state.mostProfited = data
    },
    setMostLost(state, data) {
      state.mostLost = data
    },
    setTotals(state, data) {
      state.totals = data
    },
    setLoading(state, data) {
      state.loading = data
    },
    setBigLoading(state, data) {
      state.bigLoading = data
    },
    setNoData(state, data) {
      state.noData = data
    }
  },
  actions: {
    setList({ commit }, data) {
      commit('setList', data)
    },
    setNoData({ commit }, data) {
      commit('setNoData', data)
    },
    setLoading({ commit }, data) {
      commit('setLoading', data)
    },
    setBigLoading({ commit }, data) {
      commit('setBigLoading', data)
    },
    seperateData({ commit, state }, data) {
      // get most profited items if they are more than 10 above zero
      console.log('seperateData', data)
      let mostProfited = data
        .filter(d => d.profit > 0)
        .sort((a, b) => b.profit - a.profit)
        .slice(0, state.limit)
      let mostLost = data
        .filter(d => d.profit < 0)
        .sort((a, b) => a.profit - b.profit)
        .slice(0, state.limit)
      commit('setMostProfited', mostProfited)
      commit('setMostLost', mostLost)
      commit('setLoading', false)
    },
    convertData(
      { dispatch, rootGetters, commit, state },
      { data, checkType, refs }
    ) {
      const categories = rootGetters['category/categories']
      const companies = rootGetters['company/companies']
      const games = rootGetters['game/games']
      // calculate total in, total out, total profit, total profit percent

      // let totalsPlus = {
      //   in: 0,
      //   out: 0,
      //   profit: 0
      // };
      // let totalsMinus = {
      //   in: 0,
      //   out: 0,
      //   profit: 0
      // };
      // Object.keys(data).forEach(id => {
      //   let item = data[id];
      //   if (item.in - item.out > 0) {
      //     totalsPlus.in += item.in;
      //     totalsPlus.out += item.out;
      //     totalsPlus.profit += item.in - item.out;
      //   } else {
      //     totalsMinus.in += item.in;
      //     totalsMinus.out += item.out;
      //     totalsMinus.profit += item.in - item.out;
      //   }
      // });

      // commit("setTotals", { plus: totalsPlus, minus: totalsMinus });

      if (checkType === 'all') {
        let totalsPlus = {
          in: 0,
          out: 0,
          profit: 0
        }
        let totalsMinus = {
          in: 0,
          out: 0,
          profit: 0
        }
        Object.keys(data).forEach(id => {
          let item = data[id]
          if (item.in - item.out > 0) {
            totalsPlus.in += item.in
            totalsPlus.out += item.out
            totalsPlus.profit += item.in - item.out
          } else {
            totalsMinus.in += item.in
            totalsMinus.out += item.out
            totalsMinus.profit += item.in - item.out
          }
        })

        commit('setTotals', { plus: totalsPlus, minus: totalsMinus })
        let convertedData = []
        Object.keys(data).forEach(id => {
          let item = data[id]
          // let obj = {
          //   id: id,
          //   name: id,
          //   in: item.in,
          //   out: item.out,
          //   profit: item.in - item.out,
          //   profitPercent:
          //     ((item.in - item.out) / state.totals.plus.profit) * 100
          // };

          let fCat = null
          let fComp = companies.find(company => company.id == id)

          if (fComp) {
            fCat = categories.find(category => category.id == fComp.category_id)
            if (fCat) {
              let fConv = convertedData.find(item => item.id == fCat.id)
              if (fConv) {
                // converted datada bu kategori var
                fConv.in += item.in
                fConv.out += item.out
                fConv.profit += item.in - item.out
                fConv.profitPercent =
                  ((fConv.in - fConv.out) / state.totals.plus.profit) * 100
              } else {
                // converted datada bu kategori yok
                let obj = {
                  id: fCat.id,
                  name: fCat.name,
                  in: item.in,
                  out: item.out,
                  profit: item.in - item.out,
                  profitPercent:
                    ((item.in - item.out) / state.totals.plus.profit) * 100
                }
                convertedData.push(obj)
              }
            }
          }
        })
        dispatch('seperateData', convertedData)
      } else {
        let totalsPlus = {
          in: 0,
          out: 0,
          profit: 0
        }
        let totalsMinus = {
          in: 0,
          out: 0,
          profit: 0
        }
        Object.keys(data).forEach(id => {
          let fComp = companies.find(company => company.id == id)
          let item = data[id]
          if (checkType === 'category') {
            if (fComp && fComp.category_id == refs.selected_category)
              if (item.in - item.out > 0) {
                totalsPlus.in += item.in
                totalsPlus.out += item.out
                totalsPlus.profit += item.in - item.out
              } else {
                totalsMinus.in += item.in
                totalsMinus.out += item.out
                totalsMinus.profit += item.in - item.out
              }
          } else {
            if (item.in - item.out > 0) {
              totalsPlus.in += item.in
              totalsPlus.out += item.out
              totalsPlus.profit += item.in - item.out
            } else {
              totalsMinus.in += item.in
              totalsMinus.out += item.out
              totalsMinus.profit += item.in - item.out
            }
          }
        })

        commit('setTotals', { plus: totalsPlus, minus: totalsMinus })
        let convertedData = []
        Object.keys(data).forEach(id => {
          let item = data[id]
          let obj = {
            id: id,
            name: checkType === 'game' ? item.name : id,
            in: item.in,
            out: item.out,
            profit: item.in - item.out,
            profitPercent:
              ((item.in - item.out) / state.totals.plus.profit) * 100
          }

          if (checkType === 'category') {
            console.log('should check company name')
            let foundComp = companies.find(company => company.id == id)

            if (foundComp) {
              obj.name = foundComp.name
              obj.cat_id = foundComp.category_id
            }
          } else if (checkType === 'company') {
            console.log('should check game name')
            let foundGame = games.find(game => game.id == id)
            if (foundGame) obj.name = foundGame.name
          }

          if (checkType == 'category') {
            if (refs.selected_category == obj.cat_id) {
              convertedData.push(obj)
            }
          } else {
            convertedData.push(obj)
          }
        })
        dispatch('seperateData', convertedData)
      }
    },
    async getStatList({ commit }, form) {
      const formData = await formCleanerAndArranger(form)

      let { data } = await api.post(
        `https://stats.${STAT_URL}/game/stats/list`,
        formData
      )
    },
    async getStatSum({ commit, dispatch }, form) {
      commit('setNoData', false)
      let refs = form.refs
      delete form.refs
      const formData = await formCleanerAndArranger(form)
      let checkType = 'all'
      if (refs.selected_category) checkType = 'category'
      if (refs.selected_company) checkType = 'company'
      if (refs.selected_game) checkType = 'game'

      // ATTENTION :::::::::::::::: THIS IS FOR TESTING ONLY DONT PUSH
      // formData.filter.siteid = 93;
      // formData.filter.providerid = 11;
      // formData.filter.gameid = 6303;
      let { data } = await api.post(
        `https://stats.${STAT_URL}/game/stats/sum`,
        formData
      )

      if (checkType === 'game') {
        let listData = []
        listData = Object.keys(data.data).map(key => {
          return {
            id: key,
            name: data.data[key].name,
            in: data.data[key].in,
            out: data.data[key].out,
            profit: data.data[key].in - data.data[key].out,
            profitPercent:
              data.data[key].in == 0 && data.data[key].out > 0
                ? -100
                : data.data[key].in > 0 && data.data[key].out == 0
                ? 100
                : data.data[key].in - data.data[key].out < 0
                ? '-' +
                  (
                    100 -
                    (data.data[key].in / data.data[key].out) * 100
                  ).toFixed(2)
                : (
                    100 -
                    (data.data[key].out / data.data[key].in) * 100
                  ).toFixed(2)
          }
        })
        commit('setList', listData)
      }

      if (Object.keys(data.data).length === 0) {
        commit('setNoData', true)
        dispatch('setLoading', false)
      } else dispatch('convertData', { data: data.data, checkType, refs })
    }
  },
  getters: {
    list: state => state.list,
    sum: state => state.sum,
    mostProfited: state => state.mostProfited,
    mostLost: state => state.mostLost,
    loading: state => state.loading,
    bigLoading: state => state.bigLoading,
    limit: state => state.limit,
    noData: state => state.noData,
    totals: state => state.totals
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/stat.js